<template>
    <div class="top-container">
        <div class="top-spacer-10 bottom-spacer-30">
            <div>
                <b v-if="topCreative.width > 0 && topCreative.height > 0">{{ topCreative.width }}X{{ topCreative.height }}: </b>
                <b>{{ topCreative.file_name | extractFileName }}</b>
            </div>
            <div class="inline left-float top-spacer-5">
                <img :src="topCreative.url" alt="" class="creative_image">
                <div class="text-container">
                    {{$t('select_matching_video')}}
                </div>
            </div>
        </div>

        <div v-for="(file, index) in creatives" :key="index">
            <div v-if="file.creative_type === creativeType">
                <div>
                    <b v-if="file.width > 0 && file.height > 0">{{ file.width }}X{{ file.height }}: </b>
                    <b>{{ file.file_name | extractFileName }}</b>
                </div>
                <div class="stacked left-float top-spacer-5">
                    <video v-if="file.file_type === 'video'" width="320" class="creative_video" controls><source :src="file.url" type="video/mp4"></video>
                </div>
                <div>
                    <b-button class="left-spacer-20" @click="selectVideo(file)">{{$t('select')}}</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .top-container {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        margin-bottom: 0;
        background-color: white;
        padding: 10px 20px 0 20px;
    }
    .text-container {
        padding-left: 20px;
        vertical-align: top
    }
    .creative_video {
        display: inline;
        position: relative;
    }
    .inline {
        display: inline-flex;
    }
    .left-float {
        float: left;
    }
    .top-spacer-5 {
        margin-top: 5px;
    }
    .bottom-spacer-30 {
        margin-bottom: 30px;
    }
    .left-spacer-20 {
        margin-left: 20px;
    }
</style>

<script>
    export default {
        props: {
            topCreative: Object,
            creatives: Array,
            creativeType: String,
            selectFunction: Function
        },

        filters: {
            extractFileName: function (fileName) {
                const i = fileName.indexOf('|');
                if (i > 0) {
                    return fileName.substring(0, i);
                }
                else {
                    return fileName;
                }
            }
        },

        methods: {
            selectVideo: function (selectedVideoCreative) {
                this.$emit('close');
                this.selectFunction(this.topCreative, selectedVideoCreative)
            }
        }
    }
</script>
